<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <span class="feather-icon select-none relative switch-publish">
      <vs-switch v-model="params.data.HideInList">
        <!--<span slot="on">Published</span>
        <span slot="off">Un-Published</span>-->
      </vs-switch>
    </span>
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  watch: {
    "params.data.HideInList"() {
      this.$vs.loading();
      //alert("watch:" + this.params.data.IsPublished);
      this.$store
        .dispatch("speakerManagement/updateHideInList", {
          id: this.params.id,
          HideInList: this.params.data.HideInList
        })
        .then(() => {
          this.$vs.loading.close();
          this.showChangeStatusSuccess();
        })
        .catch(err => {
          console.error(err);
          this.$vs.loading.close();
        });
    }
  },
  methods: {
    editRecord(id) {
      this.$router
        .push({
          name: "speaker-edit",
          params: {
            SpeakerId: id
          }
        })
        .catch(() => {});

      /*
              Below line will be for actual product
              Currently it's commented due to demo purpose - Above url is for demo purpose

              this.$router.push("/apps/user/user-edit/" + this.params.data.id).catch(() => {})
            */
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      });
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess();

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user was successfully deleted"
      });
    },
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: "Status changed successfully"
      });
    }
  }
};
</script>
